module.exports = __webpack_public_path__ + "media/tobeAssigned.121fe9c6.mp3";